import gopalan from "../assets/gopalan.png";
import manu from "../assets/manu.png";
import ranjan from "../assets/ranjan.png";
import ashir from "../assets/ashir.png";
import kiran from "../assets/kiran.png";

export const leadershipData = [
  {
    role: "Chairman",
    name: "Sri. A.M. Gopalan",
    type: "main",
    image: gopalan,
    para1:
      "Chairman of Sree Gokulam Group of Companies. Everyone's Gokulam Gopalan, he himself is an inspiration to anyone who has the willpower to work for their dreams. From his very humble beginnings he has carved a legacy that will be written in royal gold with pure dedication and perseverance. ",
    para2:
      "He runs a number of institutions including colleges, hospitals, research foundation, and several public schools in and out of Kerala. Under his spirited and dynamic leadership the company is now doing well with a turnover of more than 4000 crore rupees and has more than 8000 dedicated people working under various Gokulam ventures including Sree Gokulam Chit and Finance Co.Pvt. Ltd., Sree Gokulam Medical college, Trivandrum. Sree Gokulam Public School (Vadakara and Trivandrum), Sree Gokulam Hotels Pvt. Ltd. (Gokulam Park Inn Cochin; Gokulam Park, Chennai; Gayathri International, Calicut); Gokulam Nalanda Resorts, Neeleshwaram; Gokulam Sree Magazine; Sree Gokulam Food Products; Sree Gokulam Holy Aqua Mineral Water; Sree Gokulam Handicrafts; Shivapriya Ayurvedic Hospitals Pvt. Ltd. Kollam; Gokulam Cards, Chennai; Sree Gokulam Exports & Imports; Sree Gokulam Herbs & Biotech; Sree Gokulam Movies and many more. He is a great selfless human being and a philanthropist, with an absolute attitude to contribute to the society by service through business.",
    para3:
      "He has been conferred with the prestigious “GEM OF INDIA ’96” and “UDYOG RATHNA ’97” award for his outstanding contribution to the economic development of the country.",
  },
  {
    role: "CEO",
    name: "Manu M Rajan",
    type: "main",
    image: manu,
    para1:
      "The visionary pillar of our IT company. A passionate and dedicated engineering graduate from Government College of Engineering, Kannur, with a wealth of industry experience and an unwavering commitment to excellence.",
    para2:
      "Driven by his love for teaching and a relentless desire to make a difference, He has successfully transformed the landscape of industries he touched through his ventures. His journey reflects a deep-seated passion for innovation and a commitment to empowering individuals to reach their full potential",
    para3:
      "Now, as he ventures into the world of IT, He carries his passion on his sleeves, infusing the same dedication and commitment that have defined his previous successes. With a strong foundation in engineering and a proven track record of leadership, He is poised to lead our IT company to new heights, embracing challenges with enthusiasm and shaping a future where innovation thrives.",
  },
    {
    name: "Renjan Roy",
    role: "Executive Director",
    image: ranjan,
  },
  {
    name: "Ashir Ali",
    role: "Head of Engineering",
    image: ashir,
  },
    {
    name: "Kiran UK",
    role: "Head of Design",
    image: kiran,
  },
];